<template>
	<div
		v-if="!isMobileWebApp && isFullPageMode && adBanner"
		class="x-lane"
	>
		<AdButlerAd
			v-if="adBanner.isAdbutlerAd"
			:ad="adBanner"
			class="x-lane__inner-w"
			:class="{ 'has-loaded': hasLoaded }"
			:data-text="$I18n.trans('monetization.advertisement')"
			@loaded="adbutlerLoaded"
		/>
		<component
			:is="adBanner.link ? 'a' : 'div'"
			v-else-if="eventBannerImageUrl"
			ref="banner"
			:href="adBanner.link"
			:target="adBanner.link ? '_blank' : null"
			rel="noopener"
			:class="{ 'has-loaded': hasLoaded }"
			class="x-lane__inner-w"
			:data-text="$I18n.trans('monetization.advertisement')"
		>
			<img
				ref="image"
				:src="eventBannerImageUrl"
				width="320"
				height="250"
				class="x-lane__image"
			>
		</component>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import AdButlerAd from '@components/Ads/AdButlerAd.vue';

export default {
	name:       'EventBannerAd',
	components: { AdButlerAd },
	data() {
		return {
			hasLoaded: false,
		};
	},
	computed: {
		...mapGetters({
			isMobileWebApp:      'app/isMobileWebApp',
			isFullPageMode:      'app/isFullPageMode',
			event:               'event/event',
			adBanner:            'event/adBanner',
			eventBannerImageUrl: 'event/eventBannerImageUrl',
		}),
	},
	watch: {
		eventBannerImageUrl() {
			this.registerImageLoading();
		},
	},
	mounted() {
		this.registerImageLoading();
	},
	methods: {
		adbutlerLoaded(placement) {
			if (placement) {
				this.hasLoaded = true;
			}
		},
		registerImageLoading() {
			this.$nextTick(() => {
				if (this.$refs.image) {
					this.$refs.image.addEventListener('load', () => {
						this.hasLoaded = true;
					});
				}
			});
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.x-lane {
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 36px 0 24px;

	&:empty {
		display: none;
	}
}

.x-lane__inner-w {
	position: relative;

	&.has-loaded::after {
		display: block;
		content: attr(data-text);
		position: absolute;
		right: 2px;
		bottom: calc(100% - -8px);
		font-size: 14px; // stylelint-disable-line sh-waqar/declaration-use-variable, property-disallowed-list
		color: var(--color-grey-300);
	}
}

.x-lane__image {
	width: 100%;
	max-width: 300px;
	max-height: 250px;
	display: block;
}
</style>
